import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { useLoginVerify } from '../hooks/useLoginVerify';
import { useAppDispatch, useAppSelector } from '../redux/index';
import { selectIsAppInitialized } from '../redux/AppSelectors';
import { portalSettingsFetched } from '../features/PublicPortalSettings/PublicPortalSettingsSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AuthWrapper = ({
  children
}) => {
  const {
    loading: authLoading,
    isLoggedIn
  } = useLoginVerify();
  const dispatch = useAppDispatch();
  const isAppInitialized = useAppSelector(selectIsAppInitialized);
  useEffect(() => {
    const fetchSettings = async () => {
      if (isLoggedIn) {
        await dispatch(portalSettingsFetched());
      }
    };
    void fetchSettings();
  }, [isLoggedIn, dispatch]);
  if (authLoading || !isAppInitialized) {
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      blockSize: "100vh",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }
  if (isLoggedIn && isAppInitialized) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "APP_NOT_INITIALIZED"
  });
};